import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(private http: HttpClient) { }
  uploadMedia(formData: FormData): Observable<any> {
    console.log(formData)
    //return this.http.post(`https://dental-360-internal.herokuapp.com/api/v1/file-upload/upload-s3`, formData);
    return this.http.post(`https://qa-api.dentalinterface360.com/api/v1/file-upload/upload-s3`, formData);
  }
}
